import React, { useState, useEffect } from "react";
import logo from "../assets/logo.png";

const Header = ({ currentPage, setCurrentPage }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const menuItems = [
    { id: "home", label: "Ana Sayfa" },
    { id: "about", label: "Hakkımızda" },
    { id: "gallery", label: "Galeri" },
    { id: "contact", label: "İletişim" },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? "bg-white shadow-lg py-1" : "bg-white/95 shadow-md py-2"
      }`}
    >
      <div className="max-w-[1440px] mx-auto px-4">
        <div className="flex justify-between items-center">
          <div
            className="flex items-center cursor-pointer hover:scale-105 transition-transform duration-300 ml-0"
            onClick={() => {
              setCurrentPage("home");
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
          >
            <img
              src={logo}
              alt="Little Winners"
              className={`transition-all duration-300 object-contain  w-20
              }`}
            />
          </div>

          <nav
            className={`${
              isMobileMenuOpen ? "flex" : "hidden"
            } md:flex flex-col md:flex-row gap-2 absolute md:relative top-full left-0 right-0 md:top-auto bg-white md:bg-transparent p-6 md:p-0 shadow-lg md:shadow-none rounded-b-3xl md:rounded-none`}
          >
            {menuItems.map((item) => (
              <button
                key={item.id}
                onClick={() => {
                  setCurrentPage(item.id);
                  setIsMobileMenuOpen(false);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
                className={`px-6 py-2.5 rounded-full font-semibold transition-all ${
                  currentPage === item.id
                    ? "bg-gradient-to-r from-pink-500 to-orange-500 text-white shadow-md"
                    : "text-gray-700 hover:bg-pink-100"
                }`}
              >
                {item.label}
              </button>
            ))}
            <div className="flex gap-3 mt-0 md:mt-0">
              <a
                href="https://instagram.com/littlewinners06"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="w-12 h-12 bg-red-500 rounded-full flex items-center justify-center 
text-white shadow-[0_0_15px_rgba(255,0,0,0.8)] 
hover:shadow-[0_0_25px_rgba(255,0,0,1)] hover:scale-110 transition-all duration-300"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  className="w-6 h-6"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path d="M7 2C4.243 2 2 4.243 2 7v10c0 2.757 2.243 5 5 5h10c2.757 0 5-2.243 5-5V7c0-2.757-2.243-5-5-5H7zm10 2c1.654 0 3 1.346 3 3v10c0 1.654-1.346 3-3 3H7c-1.654 0-3-1.346-3-3V7c0-1.654 1.346-3 3-3h10z" />
                  <path d="M12 7a5 5 0 100 10 5 5 0 000-10zm0 2.2a2.8 2.8 0 110 5.6 2.8 2.8 0 010-5.6z" />
                  <circle cx="17.5" cy="6.5" r="0.8" />
                </svg>
              </a>
            </div>
          </nav>

          <button
            className="md:hidden w-12 h-12 bg-gradient-to-br from-pink-500 to-orange-500 rounded-full flex items-center justify-center text-white text-2xl shadow-lg"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? "✕" : "☰"}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
